// extracted by mini-css-extract-plugin
export var content = "_40-3";
export var list = "_40-4";
export var settingsContent = "_40-7";
export var settingsPanel = "_40-8";
export var state = "_40-6";
export var triggerBadge = "_40-2";
export var triggerButton = "_40-1";
export var triggerShell = "_40-0";
export var unreadDot = "_40-5";